module.exports = __webpack_public_path__ + "img/it-IT-add-to-apple-wallet.cf22d4c.svg";